<template>
    <div>
        <v-container class="nav">
            <v-btn
                icon
                class="black--text"
                @click="$router.go(-1)"
            >
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0 text-right d-none d-sm-flex justify-end"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large color="white">
                                {{ mdiPaperclip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Out-Patient Consultation Request Slip
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
    </div>
</template>

<script>
import { mdiArrowLeft, mdiPaperclip } from '@mdi/js'

export default {
    props: ['screen_width'],
    data: () => ({
        mdiArrowLeft, mdiPaperclip
    })
}
</script>
